"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _MfaLien = require("./MfaLien");

var _Route = require("../utils/Route");

require("../css/mfa-menu.css");

var _semanticUiReact = require("semantic-ui-react");

var _utilitaires = require("../utils/utilitaires");

var _MfaSeparateur = require("./MfaSeparateur");

var _MfaContexte = require("./MfaContexte");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaMenu = /*#__PURE__*/function (_Component) {
  _inherits(MfaMenu, _Component);

  var _super = _createSuper(MfaMenu);

  function MfaMenu() {
    _classCallCheck(this, MfaMenu);

    return _super.apply(this, arguments);
  }

  _createClass(MfaMenu, [{
    key: "obtenirDescription",
    value: function obtenirDescription(route) {
      var generateurDescription = route.generateurDescription,
          description = route.description,
          chemin = route.chemin,
          forcerAffichageDescription = route.forcerAffichageDescription;

      if ((0, _utilitaires.estDefini)(forcerAffichageDescription) && forcerAffichageDescription === true) {
        return description;
      } else if ((0, _utilitaires.estDefini)(generateurDescription)) {
        return generateurDescription(chemin, this.context);
      }

      return description;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var routeCourante = (0, _Route.obtenirRouteCourante)(this.props);
      var routesMenu = this.props.routes.filter(function (route) {
        return route.estLienMenu;
      });
      var lsMenu = routesMenu.reduce(function (menu, instance) {
        if (!menu[instance.groupe]) {
          menu[instance.groupe] = [];
        }

        menu[instance.groupe].push(instance);
        return menu;
      }, {});
      var len = Object.keys(lsMenu).length - 1;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-menu"
      }, Object.keys(lsMenu).map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: index
        }, lsMenu[item].map(function (route, i) {
          var actif = routeCourante && route.chemin === routeCourante.chemin;
          var className = actif ? 'mfa-ib active' : 'mfa-ib';

          var description = _this.obtenirDescription(route);

          var spanActif = null;

          if (actif && (0, _utilitaires.estDefini)(description)) {
            var mots = description.split(/ |\xa0/);
            var espace = mots.length > 1 ? ' ' : '';
            var dernierMot = mots.pop();

            var icone = /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
              name: "angle right",
              className: "fleche"
            });

            spanActif = /*#__PURE__*/_react.default.createElement("span", {
              className: "lien-fleche"
            }, espace, (0, _utilitaires.nestPasNulOuVide)(dernierMot) ? dernierMot : null, icone);
            description = mots.join(' ');
          }

          return /*#__PURE__*/_react.default.createElement("div", {
            className: "item",
            key: "menu-lien-".concat(i)
          }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
            key: "menu-lien-".concat(i),
            to: route.chemin,
            className: className
          }, /*#__PURE__*/_react.default.createElement("span", {
            style: route.styleDescription
          }, description, spanActif)));
        }), index !== len ? /*#__PURE__*/_react.default.createElement(_MfaSeparateur.MfaSeparateur, null) : null);
      }));
    }
  }]);

  return MfaMenu;
}(_react.Component);

_defineProperty(MfaMenu, "contextType", _MfaContexte.MfaContexte);

var _default = (0, _reactRouterDom.withRouter)(MfaMenu);

exports.default = _default;